import VerticalNavMenu from './VerticalNavMenu';
import useVerticalNavContextualRendering from './hooks/useVerticalNavContextualRendering';
import VerticalNavContainer from './VerticalNavContainer';
import useIsInDemoApp from '../../hooks/useIsInDemoApp';
import { usePin } from './hooks/usePin';
import { useOutsideAlerter } from './hooks/useOutsideAlerter';
import useRemoveNavPlaceholder from '../../hooks/useRemoveNavPlaceholder';
import useVerticalNavTracking from './hooks/useVerticalNavTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const VerticalNav = () => {
  const isVerticalNavEnabled = useVerticalNavContextualRendering();
  const {
    isPinned,
    setIsPinned
  } = usePin({
    isVerticalNavEnabled
  });
  const {
    verticalNavContainerRef,
    isInteractingWithVerticalNav,
    updateIsInteractingWithVerticalNav,
    tempPauseOutsideAlerter
  } = useOutsideAlerter();
  useIsInDemoApp();
  useRemoveNavPlaceholder({
    placeholderType: 'vertical-nav'
  });
  useVerticalNavTracking({
    isInteractingWithVerticalNav
  });
  if (!isVerticalNavEnabled) return null;
  return /*#__PURE__*/_jsx(VerticalNavContainer, {
    ref: verticalNavContainerRef,
    isFocusInside: isInteractingWithVerticalNav,
    updateIsInteractingWithVerticalNav: updateIsInteractingWithVerticalNav,
    isPinned: isPinned,
    setIsPinned: setIsPinned,
    tempPauseOutsideAlerter: tempPauseOutsideAlerter,
    children: /*#__PURE__*/_jsx(VerticalNavMenu, {
      isFocusInside: isInteractingWithVerticalNav
    })
  });
};